import { Menu, Layout } from "antd";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faIdCard,
  faTruck,
  faCalendarCheck,
  faCalendarPlus,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

import classes from "./DashboardLayout.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetch } from "../store/actions/user-actions";
const { Sider, Content } = Layout;

export default function DashboardLayout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const path = location.pathname;
  const isLogedIn = useSelector((state) => state.auth.accessToken);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    if (isLogedIn && user && !user.id) {
      dispatch(fetch());
    }
  }, [dispatch, isLogedIn, user]);

  const items = [
    {
      key: "/",
      label: "Home",
      path: "",
      icon: <FontAwesomeIcon icon={faHouse} />,
    },
    {
      key: "/drivers",
      label: "Manage Drivers",
      path: "drivers",
      icon: <FontAwesomeIcon icon={faIdCard} />,
    },
    {
      key: "/vehicles",
      label: "Manage Vehicles",
      path: "vehicles",
      icon: <FontAwesomeIcon icon={faTruck} />,
    },
    {
      key: "/make-booking",
      label: "Make a Booking",
      path: "make-booking",
      icon: <FontAwesomeIcon icon={faCalendarPlus} />,
    },
    {
      key: "/bookings",
      label: "Manage Bookings",
      path: "bookings",
      icon: <FontAwesomeIcon icon={faCalendarCheck} />,
    },
    {
      key: "/contacts",
      label: "Contacts",
      path: "contacts",
      icon: <FontAwesomeIcon icon={faPhone} />,
    },
  ];

  const handleMenuClick = (e) => {
    const selectedItem = items.find((item) => item.key === e.key);
    if (selectedItem) {
      navigate(selectedItem.path);
    }
  };
  return (
    <Layout className={classes.layout}>
      <Sider theme="light" className={classes.sider}>
        <Menu
          defaultSelectedKeys={["1"]}
          items={items}
          selectedKeys={[path]}
          mode="inline"
          onClick={handleMenuClick}
        />
      </Sider>
      <Content className={classes.content}>
        <Outlet />
      </Content>
    </Layout>
  );
}
